import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const StyledTableCellStrong = withStyles((theme) => ({
  head: {
    fontWeight: 'bold'
  },
  body: {
    fontSize: 12,
    fontWeight: 'bold',
    borderBottom: 'none !important'
  }
}))(TableCell);

const useStyles = makeStyles({
  table: {
    minWidth: 350
  },
  paper: {
    marginTop: 15
  }
});

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rowsA = [
  createData('EV/Revenues', '5.3x', '3.7x', '2.6x', '4.8x'),
  createData('EV/EBITDA', 'Neg.', 'Neg.', 'Neg.', 'Neg.'),
  createData('EV/EBITA', 'Neg.', 'Neg.', 'Neg.', 'Neg.'),
  createData('PER', 'Neg.', 'Neg.', 'Neg.', 'Neg.')
];

const rowsB = [
  createData('EV/Revenues', '3.4x', '2.9x', '2.5x', '2.1x'),
  createData('EV/EBITDA', 'Neg.', 'Neg.', 'Neg.', 'Neg.'),
  createData('EV/EBITA', 'Neg.', 'Neg.', 'Neg.', 'Neg.'),
  createData('PER', 'Neg.', 'Neg.', 'Neg.', 'Neg.')
];

const MultiplesTable = ({ dataSet }) => {
  const [dataFetched, setDataFetched] = useState(rowsA);
  const classes = useStyles();

  useEffect(() => {
    setDataFetched(dataSet === 'dataA' ? rowsB : rowsA);
  }, [dataSet]);

  return (
    <TableContainer className={classes.paper} component={Paper}>
      <Table aria-label="a dense table" className={classes.table} size="small">
        <TableHead>
          <TableRow>
            <StyledTableCellStrong>Multiples</StyledTableCellStrong>
            <StyledTableCellStrong align="right">2019</StyledTableCellStrong>
            <StyledTableCellStrong align="right">2021</StyledTableCellStrong>
            <StyledTableCellStrong align="right">2022</StyledTableCellStrong>
            <StyledTableCellStrong align="right">2023</StyledTableCellStrong>
          </TableRow>
        </TableHead>
        <TableBody>
          {dataFetched.map((row) => (
            <TableRow key={row.name}>
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="right">{row.calories}</TableCell>
              <TableCell align="right">{row.fat}</TableCell>
              <TableCell align="right">{row.carbs}</TableCell>
              <TableCell align="right">{row.protein}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const mapStateToProps = (state) => ({
  dataSet: state.AuthReducer.dataSet
});

export default connect(mapStateToProps, null)(MultiplesTable);
